module.exports = __webpack_public_path__ + "static/media/Logo_white.1b80417b.png";